import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { z } from 'zod';
import { zodI18nMap } from 'zod-i18n-map';
// import deTranslation from 'zod-i18n-map/locales/de/zod.json';
import enTranslation from 'zod-i18n-map/locales/en/zod.json';
// import esTranslation from 'zod-i18n-map/locales/es/zod.json';
import ruTranslation from 'zod-i18n-map/locales/ru/zod.json';

import { initReactI18next } from 'react-i18next';

// import de from './locales/de.json' assert { type: 'json' };
import en from './locales/en.json' assert { type: 'json' };
// import es from './locales/es.json' assert { type: 'json' };
import ru from './locales/ru.json' assert { type: 'json' };

export type LocalesTypes = 'de' | 'en' | 'es' | 'ru';

export type LocaleJson = typeof ru;

export interface WithZodJson extends LocaleJson {
  zod: typeof ruTranslation

  [key: string]: any,
}

export const resources: { [key in LocalesTypes]?: WithZodJson } = {
  ru: {
    ...ru,
    zod: ruTranslation,
  },
  en: {
    ...en,
    zod: enTranslation,
  },
  // // @ts-ignore
  // de: {
  //   ...de,
  //   zod: deTranslation,
  // },
  // // @ts-ignore
  // es: {
  //   ...es,
  //   zod: esTranslation,
  // },
};
const isNode = typeof window === 'undefined';
const isExportMode = isNode ? process.env.MARKET === 'export' : false;
const lng = localStorage.getItem('i18nextLng') || (isExportMode ? 'en' : 'ru');

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    lng,
    resources,
    fallbackLng: ['en'],
    interpolation: {
      escapeValue: false,
    },
  });
z.setErrorMap(zodI18nMap);

export default i18n;
